import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const resetDealHighlights = (orgId, dealId, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'RESET_DEAL_HIGHLIGHTS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/org/${orgId}/deals/${dealId}/deal-highlights-reset`,
            null,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'RESET_DEAL_HIGHLIGHTS_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'RESET_DEAL_HIGHLIGHTS_FAILED',
              payload: `Failed to process deal activity data`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'RESET_DEAL_HIGHLIGHTS_FAILED',
            payload: `Failed to process deal activity data`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'RESET_DEAL_HIGHLIGHTS_FAILED',
        payload: `Failed to process deal activity data`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default resetDealHighlights;
